import script from "./reward_item.vue?vue&type=script&setup=true&lang=js"
export * from "./reward_item.vue?vue&type=script&setup=true&lang=js"

import "./reward_item.vue?vue&type=style&index=0&id=4610c665&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4610c665"]])

export default __exports__